import { getUserFields, getdirectusUserFields } from "components/user/config";
import { getItemFromCollection } from "directus/src/operations";

export async function fetchTicketDataForForm({ id }) {
  try {
    const query = {
      fields: [
        "id",
        "title",
        "status",
        "type",
        "description",
        "attachments.attachment.id",
        "attachments.attachment.type",
        "attachments.attachment.filename_download",
        // "response",
        getUserFields("assigned_to"),
        getdirectusUserFields("user_created"),
        getdirectusUserFields("user_updated"),
        "priority",
        "date_created",
        "date_updated",
        "due_date",
      ],
    };
    const response = await getItemFromCollection("tickets", id, query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
